import React from 'react';

// Embarca o painel externo de Monitor de Ramais (https://monitorextensions.onrender.com).
// É uma página pública do Centrão hospedada no Render — sem login próprio.
// Iframe ocupa toda a área de conteúdo disponível (descontando sidebar e padding do layout).
export default function MonitorRamais() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: 'calc(100vh - 56px)' }}>
      <div className="d-flex align-items-center justify-content-between mb-2">
        <h4 className="fw-bold mb-0"><i className="bi bi-telephone-fill me-2" style={{ color: '#5C3D52' }}></i>Monitor de Ramais</h4>
        <a href="https://monitorextensions.onrender.com/" target="_blank" rel="noreferrer"
          className="btn btn-sm btn-outline-secondary" style={{ fontSize: '0.78rem' }}>
          <i className="bi bi-box-arrow-up-right me-1"></i>Abrir em nova aba
        </a>
      </div>
      <iframe
        src="https://monitorextensions.onrender.com/"
        title="Monitor de Ramais"
        style={{ flex: 1, width: '100%', border: '1px solid #e0e0e0', borderRadius: 6, background: '#fff' }}
        loading="lazy"
      />
    </div>
  );
}
